/**
 * The uid a storefront guest owns carts and orders as: the Firebase user's,
 * else — when App Check refused this browser — the uid of its API guest session
 * (`AuthSnapshot.guestUid`, services/guestSession.ts). The same Firebase uid
 * either way. Kept apart from `hooks/useAuth` so a component reading it does
 * not depend on how `useAuth` is provided (tests mock that module whole).
 */
export const customerUidOf = (
  snapshot: { firebaseUser?: { uid: string } | null; guestUid?: string | null } | null | undefined,
): string | undefined => snapshot?.firebaseUser?.uid ?? snapshot?.guestUid ?? undefined;
